"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[46],{

/***/ 46842:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(17121);
var icon = __webpack_require__(816);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(71993);
__webpack_require__(24774);

const STAR = 'M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z';
const IconStar = lib.variant('IconStar', icon.Icon, {
    path: STAR,
});

exports.G = IconStar;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 91596:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": () => (/* binding */ Badge)
/* harmony export */ });
/* unused harmony export Text */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71993);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18026);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(102);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87912);
/* harmony import */ var src_areas_expert_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20994);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    font-size: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var Badge = function(props) {
    var type = props.type;
    var t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il).t;
    var text = (0,src_areas_expert_utils__WEBPACK_IMPORTED_MODULE_5__/* .getTranslationByContentType */ .r)(type, t);
    return text ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, null, text) : null;
};
var Text = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_4__.TitleMediumText).withConfig({
    displayName: "Text",
    componentId: "sc-0-0"
})(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .layout.measurements.fontSizeMedium */ .bK.measurements.fontSizeMedium, function(p) {
    return p.theme.colors.maybeBlue700;
});


/***/ }),

/***/ 3739:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ expert_avatar)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(38689);
// EXTERNAL MODULE: ./src/components/user-avatar/index.tsx + 1 modules
var user_avatar = __webpack_require__(93538);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(102);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/components/prisjakt-icon/index.tsx


var PrisjaktIcon = function(param) {
    var className = param.className, _size = param.size, size = _size === void 0 ? 32 : _size, _color = param.color, color = _color === void 0 ? base/* brandColors.expert */.D2.expert : _color;
    return /*#__PURE__*/ react.createElement("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 40 40"
    }, /*#__PURE__*/ react.createElement("g", {
        fill: "none"
    }, /*#__PURE__*/ react.createElement("circle", {
        cx: "20",
        cy: "20",
        r: "20",
        fill: "#FFF"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: color,
        d: "M19.984 0C31.03-.008 39.992 8.939 40 19.984 40.008 31.03 31.061 39.992 20.016 40 8.97 40.008.008 31.061 0 20.016V20C0 8.958 8.944.005 19.984 0zm8.7 7.728a15.03 15.03 0 00-17.388-.009l-1.98-1.98a17.878 17.878 0 00-3.55 3.55l1.976 1.976a15.06 15.06 0 00-.016 17.442l-1.968 1.97a17.937 17.937 0 003.548 3.55l1.965-1.967a15.029 15.029 0 0017.44-.009l1.966 1.965.44-.342a17.902 17.902 0 002.76-2.768l.343-.443-1.967-1.968A14.987 14.987 0 0035.02 20l-.005-.407a14.983 14.983 0 00-2.78-8.31l1.975-1.977a17.907 17.907 0 00-3.55-3.556zm-8.689 1.72c5.833.006 10.557 4.739 10.552 10.572-.005 5.833-4.738 10.557-10.571 10.551C14.142 30.566 9.418 25.833 9.424 20l.005-.336A10.562 10.562 0 0119.995 9.448zm-.017 5.535l-.265.007A5.014 5.014 0 0014.967 20a5.02 5.02 0 005.022 5.019 5.017 5.017 0 00-.01-10.036h-.001z"
    })));
};
/* harmony default export */ const prisjakt_icon = (PrisjaktIcon);

;// CONCATENATED MODULE: ./src/areas/expert/components/expert-avatar/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  height: fit-content;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: 0;\n  right: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var ExpertAvatar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ExpertAvatar",
    componentId: "sc-0-0"
})(_templateObject());
var ExpertIcon = (0,styled_components_browser_esm["default"])(prisjakt_icon).attrs({
    color: base/* brandColors.expert */.D2.expert
}).withConfig({
    displayName: "ExpertIcon",
    componentId: "sc-0-1"
})(_templateObject1());

;// CONCATENATED MODULE: ./src/areas/expert/components/expert-avatar/index.tsx





var expert_avatar_ExpertAvatar = function(param) {
    var avatar = param.avatar, className = param.className, displayName = param.displayName, link = param.link, size = param.size, hideExpertIcon = param.hideExpertIcon;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), renderMode = ref.renderMode, linkTo = ref.linkTo;
    var children = /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(user_avatar/* UserAvatar */.Y, {
        size: size,
        avatar: avatar,
        displayName: displayName
    }), !hideExpertIcon && /*#__PURE__*/ react.createElement(ExpertIcon, {
        size: size / 3
    }));
    return /*#__PURE__*/ react.createElement(ExpertAvatar, {
        className: className
    }, link ? /*#__PURE__*/ react.createElement(clickable/* Clickable */.P, {
        to: linkTo("expertProfile", {
            semantic_id: link || ""
        }, renderMode === "native" ? {
            view: "native"
        } : undefined)
    }, children) : children);
};
/* harmony default export */ const expert_avatar = (expert_avatar_ExpertAvatar);


/***/ }),

/***/ 9131:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": () => (/* binding */ ExpertUserCard)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(38689);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.3_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(87912);
// EXTERNAL MODULE: ./src/areas/expert/components/expert-avatar/index.tsx + 2 modules
var expert_avatar = __webpack_require__(3739);
// EXTERNAL MODULE: ./src/areas/expert/types.ts
var types = __webpack_require__(99104);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(102);
;// CONCATENATED MODULE: ./src/areas/expert/components/expert-user-card/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  align-self: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  grid-area: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  grid-area: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  grid-area: 1 / 1 / 3 / 2;\n  align-self: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    display: grid;\n    grid-template-columns: ",
        "px 1fr;\n    grid-template-rows: auto auto;\n    column-gap: ",
        ";\n    transform: ",
        ";\n    z-index: ",
        ";\n\n    p {\n      margin: 0;\n    }\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    ",
        "\n    cursor: pointer;\n    max-height: ",
        "px;\n\n    &[href]:hover {\n      ",
        " {\n        color: ",
        ";\n      }\n      ",
        " {\n        color: ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





var USER_AVATAR_SIZE_SMALL = 32;
var USER_AVATAR_SIZE_MEDIUM = 48;
var sharedStyles = (0,styled_components_browser_esm.css)(_templateObject());
var NameMedium = (0,styled_components_browser_esm["default"])(variants.TitleMediumText).withConfig({
    displayName: "NameMedium",
    componentId: "sc-0-0"
})(_templateObject1(), sharedStyles, function(p) {
    return p.$showSubtitle ? "1 / 2 / 2 / 3" : "1 / 2 / 3 / 3";
});
var NameSmall = (0,styled_components_browser_esm["default"])(variants.TitleSmallText).withConfig({
    displayName: "NameSmall",
    componentId: "sc-0-1"
})(_templateObject2(), sharedStyles, function(p) {
    return p.$showSubtitle ? "1 / 2 / 2 / 3" : "1 / 2 / 3 / 3";
});
var Subtitle = (0,styled_components_browser_esm["default"])(variants.CaptionText).withConfig({
    displayName: "Subtitle",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject3(), props.$size === types/* ExpertUserCardSize.MEDIUM */.M.MEDIUM ? base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal : base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall);
});
var Avatar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Avatar",
    componentId: "sc-0-3"
})(_templateObject4());
var Expert = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Expert",
    componentId: "sc-0-4"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject5(), props.$size, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, props.$overlap ? "translateX(-".concat(props.$size * props.$overlap / 2, "px)") : "none", props.$index);
});
var Container = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "Container",
    componentId: "sc-0-5"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject6(), props.$pointer ? "cursor: pointer;" : "", props.$size, NameMedium, props.theme.text.callToActionHover, NameSmall, props.theme.text.callToActionHover);
});

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(58912);
;// CONCATENATED MODULE: ./src/areas/expert/components/expert-user-card/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}








var ExpertUserCard = function(props) {
    var className = props.className, experts = props.experts, _size = props.size, size = _size === void 0 ? types/* ExpertUserCardSize.SMALL */.M.SMALL : _size, subtitle = props.subtitle, _pointer = props.pointer, pointer = _pointer === void 0 ? false : _pointer;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), t = ref.t, renderMode = ref.renderMode, linkTo = ref.linkTo;
    var avatarSize = size === types/* ExpertUserCardSize.MEDIUM */.M.MEDIUM ? USER_AVATAR_SIZE_MEDIUM : USER_AVATAR_SIZE_SMALL;
    var container = experts.length === 1 ? clickable/* Clickable */.P : "div";
    var containerProps = experts.length === 1 && experts[0].url ? {
        to: linkTo("expertProfile", {
            semantic_id: experts[0].url
        }, renderMode === "native" ? {
            view: "native"
        } : undefined),
        isExternal: renderMode === "native",
        onClick: function() {
            if (experts[0].url) {
                (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.EXPERT_PROFILE_GO_TO */.U.EXPERT_PROFILE_GO_TO,
                    nextPage: experts[0].url
                });
            }
        }
    } : undefined;
    return /*#__PURE__*/ react.createElement(Container, _extends({
        className: className,
        as: container,
        $size: avatarSize,
        $pointer: pointer
    }, containerProps), experts.map(function(expert, index) {
        return /*#__PURE__*/ react.createElement(Expert, {
            key: expert.name,
            $index: experts.length - index,
            $overlap: index,
            $size: avatarSize
        }, /*#__PURE__*/ react.createElement(Avatar, null, /*#__PURE__*/ react.createElement(expert_avatar/* default */.Z, {
            avatar: expert.avatar,
            displayName: expert.name,
            size: avatarSize,
            hideExpertIcon: expert.hideExpertIcon
        })), experts.length === 1 && /*#__PURE__*/ react.createElement(react.Fragment, null, size === types/* ExpertUserCardSize.MEDIUM */.M.MEDIUM ? /*#__PURE__*/ react.createElement(NameMedium, {
            behavior: variants.Behavior.Oneline,
            $showSubtitle: Boolean(subtitle)
        }, expert.name) : /*#__PURE__*/ react.createElement(NameSmall, {
            behavior: variants.Behavior.Oneline,
            $showSubtitle: Boolean(subtitle)
        }, expert.name), subtitle && /*#__PURE__*/ react.createElement(Subtitle, {
            emphasis: variants.FontEmphasis.MEDIUM,
            $size: size
        }, subtitle)), experts.length > 1 && index === experts.length - 1 && // eslint-disable-next-line react/jsx-no-useless-fragment
        /*#__PURE__*/ react.createElement(react.Fragment, null, size === types/* ExpertUserCardSize.MEDIUM */.M.MEDIUM ? /*#__PURE__*/ react.createElement(NameMedium, {
            $showSubtitle: false,
            behavior: variants.Behavior.Oneline
        }, t("expert", "guide.lists-expert-plural", {
            count: experts.length
        })) : /*#__PURE__*/ react.createElement(NameSmall, {
            $showSubtitle: false,
            behavior: variants.Behavior.Oneline
        }, t("expert", "guide.lists-expert-plural", {
            count: experts.length
        }))));
    }));
};


/***/ }),

/***/ 38517:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": () => (/* binding */ TrackingSource),
  "Z": () => (/* binding */ list_of_content_cards)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/components/article-card/index.tsx + 1 modules
var article_card = __webpack_require__(8172);
// EXTERNAL MODULE: ./src/areas/expert/components/card-image/index.tsx
var card_image = __webpack_require__(11347);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(102);
;// CONCATENATED MODULE: ./src/areas/expert/toplists/components/product-images/index.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      &::after {\n        ",
        ";\n        pointer-events: none;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-auto-flow: column;\n  column-gap: ",
        ";\n  position: relative;\n  padding: 0 ",
        ";\n  align-items: center;\n  width: 100%;\n  height: ",
        ";\n\n  img {\n    max-height: 64px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var spacing100 = base/* layout.measurements.spacing100 */.bK.measurements.spacing100;
var Images = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Images",
    componentId: "sc-0-0"
})(_templateObject1(), spacing100, spacing100, function(p) {
    return p.height;
}, function(p) {
    return p.background && (0,styled_components_browser_esm.css)(_templateObject(), base/* styledUtils.overlay */.au.overlay());
});
var ProductImages = function(param) {
    var products = param.products, _selectedPosition = param.selectedPosition, selectedPosition = _selectedPosition === void 0 ? 1 : _selectedPosition, _height = param.height, height = _height === void 0 ? "auto" : _height, _background = param.background, background = _background === void 0 ? true : _background;
    // Select the two closest product images to the selected product
    var visible = 3;
    var productImages = products.filter(function(item) {
        if (selectedPosition === 1) return item.order <= visible;
        if (selectedPosition === products.length) return item.order > products.length - visible;
        return item.order === selectedPosition - 1 || item.order === selectedPosition || item.order === selectedPosition + 1;
    }).map(function(p) {
        var ref, ref1, ref2;
        return (p.image || ((ref = p.media) === null || ref === void 0 ? void 0 : ref.first)) && /*#__PURE__*/ react.createElement("img", {
            alt: p.name,
            key: p.image || ((ref1 = p.media) === null || ref1 === void 0 ? void 0 : ref1.first),
            src: p.image || ((ref2 = p.media) === null || ref2 === void 0 ? void 0 : ref2.first)
        });
    });
    return /*#__PURE__*/ react.createElement(Images, {
        background: background,
        height: height
    }, productImages);
};
/* harmony default export */ const product_images = (ProductImages);

// EXTERNAL MODULE: ./src/areas/expert/utils/index.ts
var utils = __webpack_require__(20994);
// EXTERNAL MODULE: ./src/areas/expert/types.ts
var types = __webpack_require__(99104);
// EXTERNAL MODULE: ./src/areas/expert/components/badge/index.tsx
var badge = __webpack_require__(91596);
// EXTERNAL MODULE: ./src/areas/expert/components/expert-user-card/index.tsx + 1 modules
var expert_user_card = __webpack_require__(9131);
// EXTERNAL MODULE: ./src/components/advized/tracking.ts
var tracking = __webpack_require__(16646);
// EXTERNAL MODULE: ./src/areas/expert/components/rating/index.tsx
var rating = __webpack_require__(44195);
;// CONCATENATED MODULE: ./src/areas/expert/components/list-of-content-cards/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: ",
        ";\n  left: ",
        ";\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Rating = (0,styled_components_browser_esm["default"])(rating/* default */.Z).withConfig({
    displayName: "Rating",
    componentId: "sc-0-0"
})(styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking_tracking = __webpack_require__(58912);
;// CONCATENATED MODULE: ./src/areas/expert/components/list-of-content-cards/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}












var TrackingSource;
(function(TrackingSource) {
    TrackingSource["ADVIZED_WIDGET"] = "advizedWidget";
})(TrackingSource || (TrackingSource = {}));
var ContentCards = function(param) {
    var category = param.category, className = param.className, onClick = param.onClick, items = param.items, _imageSize = param.imageSize, imageSize = _imageSize === void 0 ? 130 : _imageSize, _limit = param.limit, limit = _limit === void 0 ? 0 : _limit, _offset = param.offset, offset = _offset === void 0 ? 0 : _offset, hideExperts = param.hideExperts, trackingSource = param.trackingSource;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), market = ref.market, t = ref.t;
    var numberOfCards = limit ? limit + offset : items.length;
    var getDefaultExpert = function() {
        return {
            avatar: "".concat(market.cdn, "/g/rfe/logos/logo_v2_symbol.svg"),
            name: t("search", "editorial.defaultauthor"),
            url: undefined,
            hideExpertIcon: true
        };
    };
    var getNavigationScope = function(clickInfo) {
        switch(clickInfo.type){
            case types/* ContentTypes.ARTICLE */.b.ARTICLE:
                return tracking_tracking/* InternalNavigationScope.TOPLIST_PAGE_GO_TO */.U.TOPLIST_PAGE_GO_TO;
            case types/* ContentTypes.GUIDE */.b.GUIDE:
                return tracking_tracking/* InternalNavigationScope.GUIDE_PAGE_GO_TO */.U.GUIDE_PAGE_GO_TO;
            case types/* ContentTypes.TEST */.b.TEST:
                return tracking_tracking/* InternalNavigationScope.PRODUCT_TEST_PAGE_GO_TO */.U.PRODUCT_TEST_PAGE_GO_TO;
            case types/* ContentTypes.TOPLIST */.b.TOPLIST:
                return tracking_tracking/* InternalNavigationScope.TOPLIST_PAGE_GO_TO */.U.TOPLIST_PAGE_GO_TO;
            case types/* ContentTypes.TOPLIST_HEADLINE */.b.TOPLIST_HEADLINE:
                return tracking_tracking/* InternalNavigationScope.TOPLIST_PAGE_HEADLINE_GO_TO */.U.TOPLIST_PAGE_HEADLINE_GO_TO;
            default:
                return null;
        }
    };
    var onClickAndTracking = function(clickInfo) {
        onClick === null || onClick === void 0 ? void 0 : onClick(clickInfo);
        switch(trackingSource){
            case TrackingSource.ADVIZED_WIDGET:
                {
                    (0,tracking/* trackCategoryPageExpertCarouselCard */.t)(category === null || category === void 0 ? void 0 : category.url, clickInfo.type);
                    break;
                }
            default:
        }
        // GA4 tracking
        var scope = getNavigationScope(clickInfo);
        if (scope) {
            (0,tracking_tracking/* trackInternalNavigationClick */.p)({
                scope: scope,
                nextPage: clickInfo.url,
                index: clickInfo.index
            });
        }
    };
    var getContentCard = function(item, index) {
        switch(item.__typename){
            case types/* ContentTypes.TOPLIST_HEADLINE */.b.TOPLIST_HEADLINE:
                {
                    var ref, ref1, ref2, ref3, ref4;
                    if (!item.toplists || !item.toplists[0]) {
                        return null;
                    }
                    var list = item.toplists[0];
                    var image = (ref = list.description) === null || ref === void 0 ? void 0 : ref.find(function(d) {
                        return d.type === "image";
                    });
                    return /*#__PURE__*/ react.createElement(article_card/* ArticleCard */.T, {
                        pretitle: category,
                        className: className,
                        date: list.date,
                        onClick: function() {
                            return onClickAndTracking({
                                id: item.id,
                                title: item.name,
                                type: types/* ContentTypes.TOPLIST_HEADLINE */.b.TOPLIST_HEADLINE,
                                url: item.url,
                                index: index
                            });
                        },
                        key: item.id,
                        likes: (ref1 = list.headlineInfo) === null || ref1 === void 0 ? void 0 : ref1.likes,
                        media: (image === null || image === void 0 ? void 0 : image.data) ? /*#__PURE__*/ react.createElement(card_image/* default */.Z, {
                            src: image.data,
                            alt: list.title,
                            height: imageSize
                        }) : /*#__PURE__*/ react.createElement(product_images, {
                            height: "".concat(imageSize, "px"),
                            background: false,
                            selectedPosition: 2,
                            products: (ref2 = item.toplists[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.products) === null || ref3 === void 0 ? void 0 : ref3.map(function(p) {
                                return _objectSpread({}, p);
                            })
                        }),
                        titleAndCategory: /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(badge/* Badge */.C, {
                            type: types/* ContentTypes.TOPLIST_HEADLINE */.b.TOPLIST_HEADLINE
                        }), ": ", item.name),
                        url: item.url,
                        footer: !hideExperts && list.expert.url ? /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
                            experts: [
                                list.expert
                            ].concat(_toConsumableArray((list === null || list === void 0 ? void 0 : (ref4 = list.headlineInfo) === null || ref4 === void 0 ? void 0 : ref4.otherExperts) || []))
                        }) : null
                    });
                }
            case types/* ContentTypes.TOPLIST */.b.TOPLIST:
                {
                    var ref5, ref6, ref7, ref8;
                    var image1 = (ref5 = item.description) === null || ref5 === void 0 ? void 0 : ref5.find(function(d) {
                        return d.type === "image";
                    });
                    return /*#__PURE__*/ react.createElement(article_card/* ArticleCard */.T, {
                        pretitle: category,
                        className: className,
                        date: item.date,
                        onClick: function() {
                            return onClickAndTracking({
                                id: item.id,
                                title: item.title,
                                type: types/* ContentTypes.TOPLIST */.b.TOPLIST,
                                url: item.headlineInfo.url,
                                index: index
                            });
                        },
                        key: item.id,
                        likes: (ref6 = item.headlineInfo) === null || ref6 === void 0 ? void 0 : ref6.likes,
                        media: (image1 === null || image1 === void 0 ? void 0 : image1.data) ? /*#__PURE__*/ react.createElement(card_image/* default */.Z, {
                            src: image1.data,
                            alt: item.title,
                            height: imageSize
                        }) : /*#__PURE__*/ react.createElement(product_images, {
                            height: "".concat(imageSize, "px"),
                            products: item.products.map(function(p) {
                                return _objectSpread({}, p);
                            }),
                            background: false
                        }),
                        titleAndCategory: /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(badge/* Badge */.C, {
                            type: types/* ContentTypes.TOPLIST */.b.TOPLIST
                        }), ": ", item.title),
                        url: item.headlineInfo.url,
                        footer: !hideExperts && ((ref7 = item.expert) === null || ref7 === void 0 ? void 0 : ref7.url) ? /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
                            experts: [
                                item.expert
                            ].concat(_toConsumableArray(((ref8 = item.headlineInfo) === null || ref8 === void 0 ? void 0 : ref8.otherExperts) || []))
                        }) : null
                    });
                }
            case types/* ContentTypes.TEST */.b.TEST:
                {
                    return /*#__PURE__*/ react.createElement(article_card/* ArticleCard */.T, {
                        pretitle: category,
                        className: className,
                        date: item.date,
                        grade: item.gradeNotConverted !== undefined && /*#__PURE__*/ react.createElement(Rating, {
                            grade: item.gradeNotConverted
                        }),
                        onClick: function() {
                            return onClickAndTracking({
                                id: item.id,
                                title: item.title,
                                type: types/* ContentTypes.TEST */.b.TEST,
                                url: item.url,
                                index: index
                            });
                        },
                        key: item.id,
                        likes: item.likes,
                        media: item.imageWithSize && /*#__PURE__*/ react.createElement(card_image/* default */.Z, {
                            src: item.imageWithSize.src,
                            alt: item.imageWithSize.alt,
                            height: imageSize
                        }),
                        titleAndCategory: /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(badge/* Badge */.C, {
                            type: types/* ContentTypes.TEST */.b.TEST
                        }), ": ", item.title),
                        url: item.url,
                        footer: !hideExperts ? /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
                            experts: [
                                item.expert
                            ]
                        }) : null
                    });
                }
            case types/* ContentTypes.GUIDE */.b.GUIDE:
                {
                    return /*#__PURE__*/ react.createElement(article_card/* ArticleCard */.T, {
                        pretitle: category,
                        className: className,
                        date: item.date,
                        onClick: function() {
                            return onClickAndTracking({
                                id: item.id,
                                title: item.title,
                                type: types/* ContentTypes.GUIDE */.b.GUIDE,
                                url: item.url,
                                index: index
                            });
                        },
                        key: item.id,
                        likes: item.likes,
                        media: item.image && /*#__PURE__*/ react.createElement(card_image/* default */.Z, {
                            src: item.image.src,
                            alt: item.image.alt,
                            height: imageSize
                        }),
                        titleAndCategory: /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(badge/* Badge */.C, {
                            type: types/* ContentTypes.GUIDE */.b.GUIDE
                        }), ": ", item.title),
                        url: item.url,
                        footer: !hideExperts ? /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
                            experts: [
                                item.expert
                            ]
                        }) : null
                    });
                }
            case types/* ContentTypes.ARTICLE */.b.ARTICLE:
                {
                    return /*#__PURE__*/ react.createElement(article_card/* ArticleCard */.T, {
                        pretitle: category,
                        className: className,
                        date: item.date,
                        onClick: function() {
                            return onClickAndTracking({
                                id: item.id,
                                title: item.title,
                                type: types/* ContentTypes.ARTICLE */.b.ARTICLE,
                                url: item.link,
                                index: index
                            });
                        },
                        key: item.id,
                        media: item.image && /*#__PURE__*/ react.createElement(card_image/* default */.Z, {
                            src: item.image.src,
                            alt: item.image.alt,
                            height: imageSize
                        }),
                        titleAndCategory: item.title,
                        url: item.link,
                        footer: /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
                            pointer: true,
                            experts: [
                                getDefaultExpert()
                            ]
                        }),
                        footerPartOfLink: true
                    });
                }
            default:
                return null;
        }
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, items.sort(utils/* compareByDate */.t).map(function(item, index) {
        if (!item || !item.id || !item.__typename) {
            return null;
        }
        if (index < offset || index >= numberOfCards) {
            return null;
        }
        return getContentCard(item, index);
    }));
};
/* harmony default export */ const list_of_content_cards = (ContentCards);


/***/ }),

/***/ 44195:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_rating_rating_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46626);
/* harmony import */ var src_components_rating__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9160);
/* harmony import */ var _prisjakt_ui_icon_star__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46842);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43998);
/* harmony import */ var _prisjakt_ui_badge__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86222);






var ExpertRating = function(param) {
    var className = param.className, grade = param.grade, text = param.text, _as = param.as, as = _as === void 0 ? "badge" : _as;
    var rating = src_components_rating_rating_helper__WEBPACK_IMPORTED_MODULE_1__/* ["default"].toRoundedString */ .Z.toRoundedString(grade);
    if (as === "stars") {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_4__/* .Stars */ .tS, {
            className: className
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_rating__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            rate: grade,
            expertColors: true,
            size: "large"
        }), " ", /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_4__/* .RatingText */ .mN, null, rating));
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_4__/* .ExpertRating */ .Um, {
        className: className
    }, text && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, null, text, ": "), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_badge__WEBPACK_IMPORTED_MODULE_5__.Badge, {
        color: "BLUE_INVERTED",
        icon: _prisjakt_ui_icon_star__WEBPACK_IMPORTED_MODULE_3__/* .IconStar */ .G,
        text: rating
    }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ExpertRating);


/***/ }),

/***/ 43998:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ct": () => (/* binding */ Badge),
/* harmony export */   "Um": () => (/* binding */ ExpertRating),
/* harmony export */   "mN": () => (/* binding */ RatingText),
/* harmony export */   "tS": () => (/* binding */ Stars),
/* harmony export */   "xv": () => (/* binding */ Text)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(102);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n  font-weight: 600;\n  font-size: ",
        ";\n  line-height: 1;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: ",
        " ",
        ";\n  background: ",
        ";\n  border-radius: 20px;\n  justify-self: start;\n  font-weight: 600;\n  color: ",
        ";\n  line-height: 1;\n\n  svg {\n    margin-right: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 700;\n  font-size: ",
        ";\n  margin-left: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var _measurements = src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements */ .bK.measurements, spacing025 = _measurements.spacing025, spacing050 = _measurements.spacing050;
var ExpertRating = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "ExpertRating",
    componentId: "sc-0-0"
})(_templateObject());
var Text = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "Text",
    componentId: "sc-0-1"
})(_templateObject1(), spacing025, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeMedium */ .bK.measurements.fontSizeMedium);
var Badge = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Badge",
    componentId: "sc-0-2"
})(_templateObject2(), spacing025, spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .colorUtils.setRgbaAlpha */ .$n.setRgbaAlpha(src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .brandColors.expert */ .D2.expert, 1), function(p) {
    return p.theme.colors.base0;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);
var Stars = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Stars",
    componentId: "sc-0-3"
})(_templateObject3());
var RatingText = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "RatingText",
    componentId: "sc-0-4"
})(_templateObject4(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeMedium */ .bK.measurements.fontSizeMedium, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);


/***/ }),

/***/ 99104:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": () => (/* binding */ ExpertUserCardSize),
/* harmony export */   "b": () => (/* binding */ ContentTypes)
/* harmony export */ });
var ContentTypes;
(function(ContentTypes) {
    ContentTypes["TEST"] = "AdvizedTest";
    ContentTypes["TOPLIST"] = "AdvizedToplist";
    ContentTypes["TOPLIST_HEADLINE"] = "ToplistHeadline";
    ContentTypes["GUIDE"] = "ExpertGuide";
    ContentTypes["ARTICLE"] = "SearchArticleItem";
})(ContentTypes || (ContentTypes = {}));
var ExpertUserCardSize;
(function(ExpertUserCardSize) {
    ExpertUserCardSize["SMALL"] = "SMALL";
    ExpertUserCardSize["MEDIUM"] = "MEDIUM";
})(ExpertUserCardSize || (ExpertUserCardSize = {}));


/***/ }),

/***/ 20994:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": () => (/* binding */ getTranslationByContentType),
/* harmony export */   "t": () => (/* binding */ compareByDate)
/* harmony export */ });
/* harmony import */ var src_areas_expert_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99104);

/**
 * Compare function for sorting Adviced content in arrays
 */ var compareByDate = function(a, b) {
    // If null or undefined, move to bottom of list
    if (!a || !a.publishedAt) return 1;
    if (!b || !b.publishedAt) return -1;
    return parseInt(b.publishedAt, 10) - parseInt(a.publishedAt, 10);
};
var getTranslationByContentType = function(type, t) {
    switch(type){
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_0__/* .ContentTypes.TEST */ .b.TEST:
            return t("expert", "test.test");
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_0__/* .ContentTypes.TOPLIST */ .b.TOPLIST:
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_0__/* .ContentTypes.TOPLIST_HEADLINE */ .b.TOPLIST_HEADLINE:
            return t("expert", "toplist.toplist");
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_0__/* .ContentTypes.GUIDE */ .b.GUIDE:
            return t("expert", "guide.guide");
        default:
            return null;
    }
};


/***/ }),

/***/ 24990:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "KeywordLandingPageLoader": () => (/* binding */ KeywordLandingPageLoader),
  "default": () => (/* binding */ components)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.3_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/breadcrumbs/index.js
var breadcrumbs = __webpack_require__(68699);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/components/page/index.ts + 3 modules
var page = __webpack_require__(62372);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(58912);
// EXTERNAL MODULE: ./src/hooks/experiments.ts
var experiments = __webpack_require__(46353);
// EXTERNAL MODULE: ./src/areas/keyword-landing-page/contexts.ts
var contexts = __webpack_require__(85944);
// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(80695);
;// CONCATENATED MODULE: ./src/areas/keyword-landing-page/tracking.ts

function trackKWLPProductClick(keyword, productId) {
    (0,data_layer/* pushEvent */.A)("keywordLandingPageProductClick", {
        keyword: keyword,
        productId: productId
    });
}
function trackKWLPOfferClick(keyword, offerId) {
    (0,data_layer/* pushEvent */.A)("keywordLandingPageOfferClick", {
        keyword: keyword,
        offerId: offerId
    });
}
function trackKWLPCategoryClick(keyword, categoryName) {
    (0,data_layer/* pushEvent */.A)("keywordLandingPageCategoryClick", {
        keyword: keyword,
        categoryName: categoryName
    });
}
/**
 * Tracks all the ids of offers and products without any images.
 */ function trackKWLPNoImages(url, prodAndOfferIds) {
    (0,data_layer/* pushEvent */.A)("keywordLandingPageNoImages", {
        url: url,
        prodAndOfferIds: prodAndOfferIds
    });
}
function trackKWLPOffersOnlyVisited(keyword, pageUrl) {
    (0,data_layer/* pushEvent */.A)("keywordLandingPageOffersOnlyVisited", {
        keyword: keyword,
        pageUrl: pageUrl
    });
}
function trackKWLPNoItems(keyword, pageUrl) {
    (0,data_layer/* pushEvent */.A)("keywordLandingPageNoItems", {
        keyword: keyword,
        pageUrl: pageUrl
    });
}
function trackKWLPSingleCategoryVisited(keyword, pageUrl) {
    (0,data_layer/* pushEvent */.A)("keywordLandingPageSingleCategoryVisited", {
        keyword: keyword,
        pageUrl: pageUrl
    });
}

// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/areas/product-collection/components/navigation/navigation-component.tsx + 2 modules
var navigation_component = __webpack_require__(89343);
;// CONCATENATED MODULE: ./src/areas/keyword-landing-page/components/categories.tsx





var CategoryResults = function(param) {
    var categories = param.categories;
    var linkTo = (0,app_context/* useAppContext */.bp)().linkTo;
    var history = (0,react_router_dom/* useHistory */.k6)();
    var facetLinks = (0,react.useMemo)(function() {
        return categories.map(function(category) {
            var id = category.id, value = category.name, imageUrl = category.image;
            var path = linkTo("category", category);
            return {
                id: id,
                value: value,
                path: path,
                imageUrl: imageUrl,
                indexable: true,
                selected: false
            };
        });
    }, [
        categories,
        linkTo
    ]);
    return categories.length ? /*#__PURE__*/ react.createElement(navigation_component/* NavigationSliceView */.B, {
        links: facetLinks,
        onClickPreventDefault: true,
        onClick: function(link) {
            if (link.path) {
                history.push(link.path);
                trackKWLPCategoryClick(link.value, link.id);
            }
        }
    }) : null;
};

// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(102);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.3_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/list/variants.js
var variants = __webpack_require__(86541);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.3_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(87912);
// EXTERNAL MODULE: ./src/components/page/page-header/index.tsx + 1 modules
var page_header = __webpack_require__(57538);
;// CONCATENATED MODULE: ./src/areas/keyword-landing-page/components/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 10px;\n  margin-bottom: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin: ",
        " 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: left;\n  padding: 0 ",
        ";\n  margin: ",
        " 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  margin: ",
        " 0 ",
        "\n    ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var GUTTER = base/* layout.measurements.spacing100 */.bK.measurements.spacing100;
var SearchResults = (0,styled_components_browser_esm["default"])(variants.Column).withConfig({
    displayName: "SearchResults",
    componentId: "sc-0-0"
})(_templateObject(), GUTTER, GUTTER);
var BodyGutter = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BodyGutter",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var WrapBody = styled_components_browser_esm["default"].div.withConfig({
    displayName: "WrapBody",
    componentId: "sc-0-2"
})(_templateObject2(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200);
var PopularSearchesTitle = (0,styled_components_browser_esm["default"])(text_variants.H3Text).withConfig({
    displayName: "PopularSearchesTitle",
    componentId: "sc-0-3"
})(_templateObject3(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var BreadCrumbWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BreadCrumbWrapper",
    componentId: "sc-0-4"
})(_templateObject4(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var KwlpPageHeader = (0,styled_components_browser_esm["default"])(page_header/* default */.Z).withConfig({
    displayName: "KwlpPageHeader",
    componentId: "sc-0-5"
})(_templateObject5(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./src/components/no-results/index.tsx + 1 modules
var no_results = __webpack_require__(90369);
// EXTERNAL MODULE: ./src/components/popular-searches/index.tsx + 2 modules
var popular_searches = __webpack_require__(65110);
;// CONCATENATED MODULE: ./src/areas/keyword-landing-page/components/noItems.tsx





var NoItems = function(param) {
    var popularSearches = param.popularSearches;
    var t = (0,app_context/* useAppContext */.bp)().t;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(no_results/* NoResults */.X, {
        title: t("category", "keyword-landing-page.no-offers")
    }), (popularSearches === null || popularSearches === void 0 ? void 0 : popularSearches.length) ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(PopularSearchesTitle, null, t("search", "search.popular-searches")), /*#__PURE__*/ react.createElement(popular_searches/* PopularSearches */.S, {
        popularSearches: popularSearches
    })) : null);
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./src/areas/product-collection/components/products/layout-grid/index.tsx + 1 modules
var layout_grid = __webpack_require__(23030);
// EXTERNAL MODULE: ./src/components/layout-buttons/types.ts
var types = __webpack_require__(8458);
// EXTERNAL MODULE: ./src/globals/tracking/conversion.ts
var conversion = __webpack_require__(1043);
// EXTERNAL MODULE: ./src/areas/product/actions/product.ts + 1 modules
var product = __webpack_require__(36483);
;// CONCATENATED MODULE: ./src/areas/keyword-landing-page/components/products.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}







var ProductResults = function(param) {
    var title = param.title, items = param.items;
    var productClickHandler = function productClickHandler(id, _name, type) {
        if (type === "Offer") {
            var clickedProduct = items.find(function(p) {
                return p.__typename === "Offer" && p.offerId === id;
            });
            var offerId = clickedProduct.offerId;
            dispatch((0,product/* productPriceClick */.Po)(null, null, !!clickedProduct.store.featured, "raw"));
            if (offerId) {
                trackKWLPOfferClick(title, offerId);
                (0,conversion/* trackOfferClickWithRevenue */.Rx)({
                    scope: conversion/* TrackClickScope.KEYWORD_PAGE */.b8.KEYWORD_PAGE,
                    offerId: offerId
                });
            }
        }
        if (type === "Product") trackKWLPProductClick(title, id);
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var _obj;
    // We have this conditional logic so that we don't show the ad and the footer ad directly after each other when there aren't enough products to fill the row
    var adsLayout = (_obj = {}, _defineProperty(_obj, types/* LayoutMode.GRID */.X.GRID, {
        panorama_extra: {
            show: items.length > 20,
            row: 3
        },
        dubbelpanorama1: {
            show: items.length > 8,
            row: 3
        },
        dubbelpanorama2: {
            show: true,
            row: 8
        }
    }), _defineProperty(_obj, types/* LayoutMode.LIST */.X.LIST, {
        panorama_extra: {
            show: false,
            row: 2
        },
        dubbelpanorama1: {
            show: true,
            row: 3
        },
        dubbelpanorama2: {
            show: true,
            row: 8
        }
    }), _defineProperty(_obj, types/* LayoutMode.COMPACT_LIST */.X.COMPACT_LIST, {
        panorama_extra: {
            show: false,
            row: 2
        },
        dubbelpanorama1: {
            show: true,
            row: 3
        },
        dubbelpanorama2: {
            show: true,
            row: 15
        }
    }), _obj);
    // In hope of showing images on Google, we use the 280px variant of the image for the first product
    var firstProduct = items.find(function(p) {
        return p.__typename === "Product";
    });
    if (firstProduct) {
        firstProduct.media.first = // Also fall back on empty string
        firstProduct.media.firstLarge || firstProduct.media.first;
    }
    return /*#__PURE__*/ react.createElement(layout_grid/* GridLayout */.M, {
        isExtraWide: true,
        // This is a faulty assertion, but we're leaving KWLP domain and fixing that as well is out of scope for this cleanup session
        // TODO
        products: items,
        adslayoutConfig: adsLayout,
        onClick: productClickHandler
    });
};

// EXTERNAL MODULE: ./src/hooks/use-matched-route.ts
var use_matched_route = __webpack_require__(5148);
// EXTERNAL MODULE: ./src/areas/keyword-landing-page/query.graphql
var query_graphql = __webpack_require__(25559);
var query_graphql_default = /*#__PURE__*/__webpack_require__.n(query_graphql);
// EXTERNAL MODULE: ./src/hooks/use-page-query.ts
var use_page_query = __webpack_require__(98854);
;// CONCATENATED MODULE: ./src/areas/keyword-landing-page/queries/useKeywordLandingPage.ts


function useKeywordLandingPageQuery(variables) {
    return (0,use_page_query/* usePageQuery */.v)({
        query: (query_graphql_default()),
        routeName: "keywordLandingPage",
        variables: variables
    });
}

// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(30082);
// EXTERNAL MODULE: ./src/contexts/wide-context.tsx
var wide_context = __webpack_require__(59547);
// EXTERNAL MODULE: ./src/hooks/use-feedback.ts
var use_feedback = __webpack_require__(81268);
;// CONCATENATED MODULE: ./src/areas/keyword-landing-page/components/kwlp-information/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  cursor: pointer;\n  color: ",
        ";\n  text-align: center;\n  line-height: 1.5;\n  &:hover {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var KwlpInformation = styled_components_browser_esm["default"].div.withConfig({
    displayName: "KwlpInformation",
    componentId: "sc-0-0"
})(styles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.tertiary;
}, base/* layout.fontSizes.base.desktop.rem */.bK.fontSizes.base.desktop.rem);
var Link = styled_components_browser_esm["default"].button.withConfig({
    displayName: "Link",
    componentId: "sc-0-1"
})(styles_templateObject1(), function(p) {
    return p.theme.text.linkExternal;
}, function(p) {
    return p.theme.text.linkExternalHover;
});

;// CONCATENATED MODULE: ./src/areas/keyword-landing-page/components/kwlp-information/index.tsx




var kwlp_information_KwlpInformation = function() {
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var ref = (0,use_feedback/* useFeedback */.Z)(), loadState = ref.loadState, loadFeedback = ref.loadFeedback;
    var isLoading = loadState === "loading";
    return /*#__PURE__*/ react.createElement(KwlpInformation, null, t("feedback", "keyword-landing-page.ai-keyword-feedback", {
        contact: /*#__PURE__*/ react.createElement(Link, {
            type: "button",
            onClick: loadFeedback,
            disabled: isLoading
        }, t("feedback", "keyword-landing-page.contact"))
    }));
};
/* harmony default export */ const kwlp_information = (/*#__PURE__*/(0,react.memo)(kwlp_information_KwlpInformation));

;// CONCATENATED MODULE: ./src/areas/keyword-landing-page/components/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


















var KEYWORDAI = 6;
var KeywordLandingPageLoader = function() {
    var ref;
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var limit = (0,experiments/* useKWLPLimitProducts */.aP)();
    var setIsWide = (0,react.useContext)(wide_context/* WideContext */.Y).setIsWide;
    var ref1;
    var ref2 = (ref1 = route === null || route === void 0 ? void 0 : (ref = route.match) === null || ref === void 0 ? void 0 : ref.params) !== null && ref1 !== void 0 ? ref1 : {}, slug = ref2.slug, query = ref2.query, source = ref2.source;
    var keywordLandingPageQuery = useKeywordLandingPageQuery({
        slug: slug,
        query: query ? decodeURI(query) : undefined,
        source: source === "keywordAI" ? source : undefined,
        offset: 0,
        limit: limit
    });
    var data = keywordLandingPageQuery.data, isLoading = keywordLandingPageQuery.isLoading, isSuccess = keywordLandingPageQuery.isSuccess;
    (0,react.useEffect)(function() {
        setIsWide(true);
        return function() {
            setIsWide(false);
        };
    }, [
        setIsWide
    ]);
    if (!isLoading && !isSuccess) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(contexts/* IsKWLPContext.Provider */.e.Provider, {
        value: true
    }, /*#__PURE__*/ react.createElement(page/* PageContent */.JH, {
        withAds: true,
        topPlacements: [],
        "data-test": "KeywordLandingPage"
    }, isLoading ? /*#__PURE__*/ react.createElement(loader/* default */.Z, null) : null, data ? /*#__PURE__*/ react.createElement(KeywordLandingPage, {
        data: data
    }) : null));
};
/* harmony default export */ const components = (KeywordLandingPageLoader);
var KeywordLandingPage = function(param) {
    var _data = param.data, data = _data.keywordLandingPage, popularSearches = _data.popularSearches;
    var ref;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var url = data.url, _items = data.items, items = _items.nodes, _categories = data.categories, categories = _categories.nodes, title = data.title;
    var ref1 = _slicedToArray(items.reduce(function(param, po) {
        var _param = _slicedToArray(param, 2), ps = _param[0], os = _param[1];
        if (po.__typename === "Product") {
            ps.push(po);
        } else {
            os.push(po);
        }
        return [
            ps,
            os
        ];
    }, [
        [],
        []
    ]), 2), products = ref1[0], offers = ref1[1];
    var isOffersOnly = products.length === 0 && offers.length >= 1;
    if (isOffersOnly && title && url) {
        trackKWLPOffersOnlyVisited(title, url);
    }
    if (categories.length === 1) {
        trackKWLPSingleCategoryVisited(title, url);
    }
    var itemsWithoutImageIDs = items.filter(function(item) {
        return !item.media.first;
    }).map(function(item) {
        return item.__typename === "Product" ? item.id : item.offerId;
    });
    if (itemsWithoutImageIDs.length) {
        trackKWLPNoImages(data.url, itemsWithoutImageIDs.join(","));
    }
    var ref2;
    var breadcrumbPath = _toConsumableArray((ref2 = (ref = data.parentCategory) === null || ref === void 0 ? void 0 : ref.path) !== null && ref2 !== void 0 ? ref2 : []).concat([
        {
            id: title,
            name: title,
            pathName: ""
        }
    ]);
    // Add this type so that we use the fancy alias instead
    var finalItems = items;
    var deprioritizeNoImageOffers = (0,experiments/* useKWLPDeprioritizeNoImageOffers */.Ih)();
    if (deprioritizeNoImageOffers) {
        finalItems = finalItems.reduce(function(param, curr) {
            var _param = _slicedToArray(param, 2), withImage = _param[0], withoutImage = _param[1];
            if ((curr === null || curr === void 0 ? void 0 : curr.__typename) === "Offer" && !curr.media.first) {
                withoutImage.push(curr);
            } else {
                withImage.push(curr);
            }
            return [
                withImage,
                withoutImage
            ];
        }, [
            [],
            []
        ]).flat();
    }
    if (!(data.published && finalItems.length)) {
        trackKWLPNoItems(title, url);
    }
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(BreadCrumbWrapper, null, /*#__PURE__*/ react.createElement(breadcrumbs/* Breadcrumbs */.O, {
        containerProps: {
            onClick: function(nextPage) {
                (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.BREADCRUMB */.U.BREADCRUMB,
                    nextPage: nextPage
                });
            }
        }
    }, /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: "/"
    }, t("common", "breadcrumb.home")), breadcrumbPath.map(function(item, index) {
        return breadcrumbPath.length - 1 === index ? /*#__PURE__*/ react.createElement("span", {
            key: item.id
        }, item.name) : /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
            key: item.id,
            to: item.pathName
        }, item.name);
    }))), /*#__PURE__*/ react.createElement(KwlpPageHeader, {
        title: title,
        description: data.sourceId === KEYWORDAI ? data.metaDescription : null
    }), data.published && finalItems.length ? /*#__PURE__*/ react.createElement(SearchResults, null, /*#__PURE__*/ react.createElement(CategoryResults, {
        categories: categories
    }), /*#__PURE__*/ react.createElement(ProductResults, {
        title: title,
        items: finalItems
    }), data.sourceId === KEYWORDAI ? /*#__PURE__*/ react.createElement(kwlp_information, null) : null) : /*#__PURE__*/ react.createElement(NoItems, {
        popularSearches: popularSearches
    }));
};


/***/ }),

/***/ 89343:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": () => (/* binding */ NavigationSliceView)
});

// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/horizontal-scroll/index.tsx + 1 modules
var horizontal_scroll = __webpack_require__(55913);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.3_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(87912);
// EXTERNAL MODULE: ./src/components/viewport/index.tsx
var viewport = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/lazy/index.tsx
var lazy = __webpack_require__(67506);
// EXTERNAL MODULE: ./src/components/media-button/index.tsx + 1 modules
var media_button = __webpack_require__(26860);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(102);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/navigation/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    max-width: calc(100vw - 120px);\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: nowrap;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      height: 140px;\n      overflow: hidden;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  justify-content: flex-start;\n  grid-template-columns: repeat(auto-fit, minmax(120px, auto));\n  flex-wrap: wrap;\n  list-style: none;\n  flex-grow: 1;\n  margin-bottom: 0;\n  row-gap: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  min-width: ",
        "px;\n  max-width: ",
        "px;\n  min-height: 140px;\n  display: block;\n  margin-left: 5px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  flex-grow: 1;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  line-height: ",
        "rem;\n  max-height: ",
        "rem;\n  word-break: break-word;\n  white-space: normal;\n  overflow: hidden;\n  /* stylelint-disable value-no-vendor-prefix  */\n  display: -webkit-box;\n  /* stylelint-disable property-no-vendor-prefix  */\n  -webkit-line-clamp: ",
        ";\n  -webkit-box-orient: vertical;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: ",
        "px;\n  height: ",
        "px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  display: block;\n  grid-column-end: -1;\n  grid-row-start: 1;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        "px;\n  height: ",
        "px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  margin-right: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var ITEM_WIDTH = 120;
var MEDIA_SIZE = 60;
var Wrapper = styled_components_browser_esm["default"].section.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-0"
})(_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.largeUp */.BC.largeUp(_templateObject()));
var ListWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ListWrapper",
    componentId: "sc-0-1"
})(_templateObject2());
var List = styled_components_browser_esm["default"].ul.attrs({
    "data-test": "NavigationList"
}).withConfig({
    displayName: "List",
    componentId: "sc-0-2"
})(_templateObject4(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, function(p) {
    return !p.$showAll && (0,styled_components_browser_esm.css)(_templateObject3());
});
var listItemStyles = (0,styled_components_browser_esm.css)(_templateObject5(), ITEM_WIDTH, ITEM_WIDTH);
var ListItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "ListItem",
    componentId: "sc-0-3"
})(_templateObject6(), listItemStyles);
var ListItemDiv = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ListItemDiv",
    componentId: "sc-0-4"
})(_templateObject7(), listItemStyles);
var ListItemText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ListItemText",
    componentId: "sc-0-5"
})(_templateObject8());
var numberWithDefault = function(value, defaultValue) {
    return value !== undefined ? value : defaultValue;
};
var LimitedTextField = styled_components_browser_esm["default"].div.attrs(function(param) {
    var lines = param.lines;
    return {
        maxLines: numberWithDefault(lines, 2)
    };
}).withConfig({
    displayName: "LimitedTextField",
    componentId: "sc-0-6"
})(_templateObject9(), function(param) {
    var lineHeight = param.lineHeight;
    return numberWithDefault(lineHeight, 1.2);
}, function(param) {
    var lines = param.lines, lineHeight = param.lineHeight;
    return numberWithDefault(lines, 2) * numberWithDefault(lineHeight, 1.2);
}, function(param) {
    var lines = param.lines;
    return lines !== undefined ? lines : "none";
});
var ListItemImage = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ListItemImage",
    componentId: "sc-0-7"
})(_templateObject10(), MEDIA_SIZE, MEDIA_SIZE);
var ListAction = styled_components_browser_esm["default"].div.attrs({
    "data-test": "NavigationListAction"
}).withConfig({
    displayName: "ListAction",
    componentId: "sc-0-8"
})(_templateObject11(), listItemStyles);
var ListActionButton = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ListActionButton",
    componentId: "sc-0-9"
})(_templateObject12(), MEDIA_SIZE, MEDIA_SIZE);
var NavigationSliceWrapper = styled_components_browser_esm["default"].div.attrs({
    "data-test": "NavigationList"
}).withConfig({
    displayName: "NavigationSliceWrapper",
    componentId: "sc-0-10"
})(_templateObject13(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/product-collection/components/navigation/link.tsx





var NavigationLink = function(param) {
    var link = param.link, selected = param.selected, onClickPreventDefault = param.onClickPreventDefault, Component = param.Component, onClick = param.onClick, _lazyLoadImage = param.lazyLoadImage, lazyLoadImage = _lazyLoadImage === void 0 ? true : _lazyLoadImage;
    var onClickHandler = (0,react.useCallback)(function(e) {
        // Help google with a-links, but handle filter updates via actions
        if (onClick) {
            if (onClickPreventDefault) {
                e.preventDefault();
            }
            onClick(link);
        }
    }, [
        link,
        onClick,
        onClickPreventDefault
    ]);
    var children = (0,react.useMemo)(function() {
        var image = link.imageUrl;
        if (!image) {
            return /*#__PURE__*/ react.createElement(variants.H1Text, {
                container: "span",
                emphasis: variants.FontEmphasis.LOW
            }, link.value.replace(/[^\w]+/, "").charAt(0));
        }
        var img = /*#__PURE__*/ react.createElement("img", {
            src: image,
            alt: link.value
        });
        if (lazyLoadImage) {
            return /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, {
                offset: 0
            }, img);
        }
        return img;
    }, [
        lazyLoadImage,
        link.imageUrl,
        link.value
    ]);
    var addSpaceBetweenSpecialCharacters = function(input) {
        var specialCharacters = RegExp("([^\\p{L}\\p{N}\\s])", "gu");
        return input.replace(specialCharacters, " $1 ");
    };
    return /*#__PURE__*/ react.createElement(Component, {
        selected: selected,
        "data-test": "NavigationLink",
        "data-cy": link.value
    }, /*#__PURE__*/ react.createElement(media_button/* MediaButton */._, {
        media: /*#__PURE__*/ react.createElement(ListItemImage, null, children),
        url: link.indexable && link.path || undefined,
        onClick: onClickHandler
    }, /*#__PURE__*/ react.createElement(ListItemText, null, /*#__PURE__*/ react.createElement(LimitedTextField, {
        lines: 2
    }, /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
        color: variants.FontColor.DARK
    }, addSpaceBetweenSpecialCharacters(link.value))))));
};
/* harmony default export */ const navigation_link = (NavigationLink);

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(58912);
// EXTERNAL MODULE: ./src/hooks/resize-observer.ts
var resize_observer = __webpack_require__(2613);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/navigation/navigation-component.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}










var DEFAULT_ITEM_LIMIT = 7;
var renderNavigationLinks = function(param) {
    var links = param.links, onClick = param.onClick, onClickPreventDefault = param.onClickPreventDefault, __showAll = param._showAll, _showAll = __showAll === void 0 ? true : __showAll, _asListItems = param.asListItems, asListItems = _asListItems === void 0 ? false : _asListItems, _itemLimit = param.itemLimit, itemLimit = _itemLimit === void 0 ? DEFAULT_ITEM_LIMIT : _itemLimit;
    return links && links.length ? links.map(function(link, index) {
        var selected = link.selected;
        var Component = asListItems ? ListItem : ListItemDiv;
        return link.path ? /*#__PURE__*/ react.createElement(navigation_link, {
            key: link.value,
            link: link,
            selected: selected,
            onClick: function(facetLink) {
                return onClick === null || onClick === void 0 ? void 0 : onClick(facetLink, index);
            },
            onClickPreventDefault: onClickPreventDefault,
            // Lazy loading is disabled for all initially visible images to enable them
            // to load before React is loaded. The goal of this strategy is to improve
            // our Lighthouse performance score, and specifically the "Largest Contentful
            // Paint" metric.
            lazyLoadImage: index >= itemLimit,
            Component: Component
        }) : null;
    }) : null;
};
var NavigationSliceView = function(param) {
    var links = param.links, onClick = param.onClick, _onClickPreventDefault = param.onClickPreventDefault, onClickPreventDefault = _onClickPreventDefault === void 0 ? false : _onClickPreventDefault, _itemLimit = param.itemLimit, itemLimit = _itemLimit === void 0 ? DEFAULT_ITEM_LIMIT : _itemLimit, _showAll = param.showAll, showAll = _showAll === void 0 ? false : _showAll, className = param.className;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var ref = _slicedToArray((0,react.useState)(false), 2), _showAll1 = ref[0], _setShowAll = ref[1];
    var onShowAll = (0,react.useCallback)(function() {
        return _setShowAll(!_showAll1);
    }, [
        _showAll1,
        _setShowAll
    ]);
    var trackOnClick = function(link, index) {
        if (link.path) (0,tracking/* trackInternalNavigationClick */.p)({
            scope: tracking/* InternalNavigationScope.NAVIGATION_CAROUSEL */.U.NAVIGATION_CAROUSEL,
            nextPage: link.path,
            index: index
        });
        onClick === null || onClick === void 0 ? void 0 : onClick(link);
    };
    var mobileLinks = renderNavigationLinks({
        links: links,
        onClick: trackOnClick,
        onClickPreventDefault: onClickPreventDefault,
        itemLimit: itemLimit
    });
    var desktopLinks = renderNavigationLinks({
        links: links,
        onClick: trackOnClick,
        onClickPreventDefault: onClickPreventDefault,
        _showAll: _showAll1,
        asListItems: true,
        itemLimit: itemLimit
    });
    var ref1 = (0,resize_observer/* useResizeObserver */.y)(), ref2 = ref1.ref, width = ref1.width;
    var showMore = (0,react.useMemo)(function() {
        if (!(links === null || links === void 0 ? void 0 : links.length) || !width) return false;
        return Math.floor(width / 120) < links.length;
    }, [
        links,
        width
    ]);
    return mobileLinks || desktopLinks ? /*#__PURE__*/ react.createElement(Wrapper, {
        className: className
    }, mobileLinks && /*#__PURE__*/ react.createElement(viewport/* default */.Z, {
        mobile: true,
        tablet: true
    }, /*#__PURE__*/ react.createElement(horizontal_scroll/* HorizontalScroll */.Z, {
        itemWidth: 110,
        loadingHeight: 140,
        showArrows: false
    }, mobileLinks)), desktopLinks && /*#__PURE__*/ react.createElement(viewport/* default */.Z, {
        desktop: true
    }, /*#__PURE__*/ react.createElement(ListWrapper, {
        ref: ref2
    }, /*#__PURE__*/ react.createElement(List, {
        $showAll: showAll || _showAll1,
        $itemLimit: itemLimit
    }, showMore && links && links.length > itemLimit && !showAll ? /*#__PURE__*/ react.createElement(ListAction, null, /*#__PURE__*/ react.createElement(media_button/* MediaButton */._, {
        onClick: onShowAll,
        media: /*#__PURE__*/ react.createElement(ListActionButton, null, /*#__PURE__*/ react.createElement(variants.TitleSmallText, null, t("common", _showAll1 ? "button.show-less" : "button.show-more")))
    })) : null, desktopLinks)))) : null;
};


/***/ }),

/***/ 7846:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": () => (/* binding */ OffersGrid)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23880);


var OffersGrid = function(param) {
    var children = param.children, className = param.className, offers = param.offers, isExtraWide = param.isExtraWide, isOffers = param.isOffers;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_1__/* .OffersGrid */ .u5, {
        "data-test": isOffers ? "OfferGrid" : "ProductGrid",
        className: className,
        isExtraWide: isExtraWide
    }, children, offers && react__WEBPACK_IMPORTED_MODULE_0__.Children.map(offers, function(child, index) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_1__/* .OffersGridItem */ .EA, {
            "data-test": isOffers ? "OfferGridCard" : "ProductGridCard",
            style: {
                order: index
            }
        }, child);
    }));
};


/***/ }),

/***/ 23880:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EA": () => (/* binding */ OffersGridItem),
/* harmony export */   "cq": () => (/* binding */ ITEMS),
/* harmony export */   "u5": () => (/* binding */ OffersGrid)
/* harmony export */ });
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(102);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71993);
/* harmony import */ var src_components_base_styles_variables__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11093);
/* eslint-disable no-nested-ternary */ function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n          grid-gap: ",
        "rem;\n          grid-template-columns: repeat(\n            auto-fill,\n            minmax(auto, calc(",
        " - ",
        "))\n          );\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    @supports (grid-template-columns: repeat(auto-fill, minmax(auto, 50%))) {\n      display: grid;\n      flex: 1 0 auto;\n      list-style: none;\n\n      ",
        "\n      ",
        "\n    }\n\n    /* Fallback to flex if grid-template-columns is not supported */\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



// We need to cover ALL breakpoints here since we use '`${breakpoint}Only`'
// If we left out xxl for example, then >1600px would look very weird as it wouldn't be covered by any breakpoint
// (This only works because the smallest and largest breakpoints are open in their respective direction)
var ITEMS = {
    small: 2,
    medium: 3,
    large: 4,
    xlarge: 4,
    xxlarge: 4
};
var GAPS = {
    small: 0.5,
    medium: 1,
    large: 1,
    xlarge: 1,
    xxlarge: 1
};
// These are calculated for each render
var SIZES = {};
var GUTTERS = {};
/**
 * Certain experiments require a different grid layout, which is passed as props
 * Here we determine how many items to show depending on the passed props
 */ function getItemsForExperiments(param) {
    var isExtraWide = param.isExtraWide;
    if (isExtraWide) {
        return {
            large: 4,
            xlarge: 5,
            xxlarge: 6
        };
    }
    return {
        large: 4,
        xlarge: 4,
        xxlarge: 4
    };
}
var OffersGrid = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].ul.withConfig({
    displayName: "OffersGrid",
    componentId: "sc-0-0"
})(function(props) {
    // We need to mutate the object here because src/areas/product-collection/components/products/layout-grid/layout-grid.tsx relies on the current layout configuration, and that depends on getItemsForExperiment
    // We don't want to implement the same logic twice, therefore we need to access this object from somewhere else
    Object.assign(ITEMS, getItemsForExperiments(props));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // I'm not really happy with the current solution, but if we dynamically change ITEMS.large etc. for each render, then we also need to recalculate (gutter) sizes for each render
        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for(var _iterator = src_components_base_styles_variables__WEBPACK_IMPORTED_MODULE_2__/* .breakpointNames */ .PS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var bp = _step.value;
            SIZES[bp] = "".concat(100 / ITEMS[bp], "%");
            GUTTERS[bp] = "".concat(GAPS[bp] * (ITEMS[bp] - 1), "rem / ").concat(ITEMS[bp]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject1(), /* This only works because smallOnly and xxlargeOnly have no boundaries in each unset direction i.e. everything larger than xxlarge is considered xxlarge */ null, src_components_base_styles_variables__WEBPACK_IMPORTED_MODULE_2__/* .breakpointNames.map */ .PS.map(function(breakpoint) {
        return src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC["".concat(breakpoint, "Only")](_templateObject(), GAPS[breakpoint], SIZES[breakpoint], GUTTERS[breakpoint]);
    }));
});
var OffersGridItem = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].li.withConfig({
    displayName: "OffersGridItem",
    componentId: "sc-0-1"
})(_templateObject2());


/***/ }),

/***/ 23030:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": () => (/* reexport */ GridLayout)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(102);
// EXTERNAL MODULE: ./src/hooks/use-is-authenticated.ts
var use_is_authenticated = __webpack_require__(32990);
// EXTERNAL MODULE: ./src/components/action-buttons/add-to-list/index.tsx
var add_to_list = __webpack_require__(27890);
// EXTERNAL MODULE: ./src/components/layout-buttons/types.ts
var types = __webpack_require__(8458);
// EXTERNAL MODULE: ./src/components/product-card-new/index.tsx + 23 modules
var product_card_new = __webpack_require__(35181);
// EXTERNAL MODULE: ./src/components/advized/index.tsx + 1 modules
var advized = __webpack_require__(48867);
// EXTERNAL MODULE: ./src/areas/product-collection/utils/products.ts
var utils_products = __webpack_require__(27551);
// EXTERNAL MODULE: ./src/areas/product-collection/components/ads/index.tsx + 1 modules
var ads = __webpack_require__(36866);
// EXTERNAL MODULE: ./src/areas/product-collection/components/offers-grid/index.tsx
var offers_grid = __webpack_require__(7846);
// EXTERNAL MODULE: ./src/areas/product-collection/components/products/highlighted-search-result.tsx
var highlighted_search_result = __webpack_require__(3049);
// EXTERNAL MODULE: ./src/components/base/styles/variables.ts
var variables = __webpack_require__(11093);
// EXTERNAL MODULE: ./src/areas/product-collection/components/offers-grid/styles.ts
var styles = __webpack_require__(23880);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(58912);
// EXTERNAL MODULE: ./src/components/product-card-new/product-card-context.tsx
var product_card_context = __webpack_require__(99816);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/layout-grid.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "grid-column: 1 / span ",
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  grid-row: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
















var IMAGES_PER_ROW_MOBILE = 2;
var ProductCardWrapper = function(param) {
    var deselectProductById = param.deselectProductById, isSelectingProducts = param.isSelectingProducts, _lazyLoadImage = param.lazyLoadImage, lazyLoadImage = _lazyLoadImage === void 0 ? true : _lazyLoadImage, _showCategoryButton = param.showCategoryButton, showCategoryButton = _showCategoryButton === void 0 ? false : _showCategoryButton, onClick = param.onClick, product = param.product, hasExpertBadge = param.hasExpertBadge, selectProductById = param.selectProductById, selectedProducts = param.selectedProducts;
    var ref, ref1;
    var isAuthenticated = (0,use_is_authenticated/* useIsAuthenticated */.k)();
    var raw = (0,utils_products/* isRaw */._)(product);
    var id;
    var offerId = "";
    if (!raw) {
        id = product.id;
    } else if (product.__typename === "Offer") {
        var _offerId;
        offerId = (_offerId = product.offerId) !== null && _offerId !== void 0 ? _offerId : "";
    } else if (product.__typename === "Raw") {
        offerId = "".concat(product.id);
    }
    var dealsDiffPercentage = product === null || product === void 0 ? void 0 : (ref = product.dealInfo) === null || ref === void 0 ? void 0 : ref.dealPercentage;
    var onClickHandler = (0,react.useCallback)(function() {
        return onClick && onClick({
            id: id !== null && id !== void 0 ? id : offerId,
            name: product.name,
            type: product.__typename
        });
    }, [
        id,
        offerId,
        onClick,
        product.__typename,
        product.name
    ]);
    var onSelect = (0,react.useCallback)(function() {
        return selectProductById && selectProductById(id, "productCard");
    }, [
        id,
        selectProductById
    ]);
    var onDeselect = (0,react.useCallback)(function() {
        return deselectProductById && deselectProductById(id, "productCard");
    }, [
        id,
        deselectProductById
    ]);
    var getPrice = function() {
        switch(product.__typename){
            case "Product":
                return product.priceSummary.regular;
            case "Offer":
                return product.offerPrice.regular;
            case "Raw":
                return product.price;
            default:
                return undefined;
        }
    };
    return !raw ? /*#__PURE__*/ react.createElement(product_card_context/* ProductCardContextContainer */.h, {
        ActionArea: isAuthenticated && !isSelectingProducts && /*#__PURE__*/ react.createElement(add_to_list/* AddToListButton */.a, {
            productId: product.id,
            productName: product.name
        }),
        diffPercentage: dealsDiffPercentage,
        hasExpertBadge: hasExpertBadge,
        highlightedName: product.highlight ? /*#__PURE__*/ react.createElement(highlighted_search_result/* default */.Z, null, product.highlight) : undefined,
        onClick: onClickHandler,
        product: product,
        selectStates: {
            onDeselect: onDeselect,
            onSelect: onSelect,
            selectable: isSelectingProducts,
            selected: selectedProducts ? selectedProducts.some(function(p) {
                return p.id === id;
            }) : false
        },
        shouldLazyLoadImage: lazyLoadImage,
        showCategoryButton: showCategoryButton
    }, /*#__PURE__*/ react.createElement(product_card_new/* ProductGridCard */.r4, null)) : /*#__PURE__*/ react.createElement(product_card_context/* ProductCardContextContainer */.h, {
        onClick: onClickHandler,
        product: _objectSpreadProps(_objectSpread({}, product), {
            media: product.__typename === "Offer" ? product.media : undefined,
            pathName: ((ref1 = product.store) === null || ref1 === void 0 ? void 0 : ref1.featured) ? product.externalUri : undefined,
            priceSummary: {
                regular: getPrice()
            }
        }),
        showCategoryButton: showCategoryButton,
        type: "offer"
    }, /*#__PURE__*/ react.createElement(product_card_new/* ProductGridCard */.r4, null));
};
var GridLayout = function(_param) {
    var feedbackPrompt = _param.feedbackPrompt, _feedbackPromptPosition = _param.feedbackPromptPosition, feedbackPromptPosition = _feedbackPromptPosition === void 0 ? 6 : _feedbackPromptPosition, onClick = _param.onClick, products = _param.products, expert = _param.expert, adslayoutConfig = _param.adslayoutConfig, isExtraWide = _param.isExtraWide, hasFeedback = _param.hasFeedback, _showCategoryButton = _param.showCategoryButton, showCategoryButton = _showCategoryButton === void 0 ? false : _showCategoryButton, productComparisonProps = _objectWithoutProperties(_param, [
        "feedbackPrompt",
        "feedbackPromptPosition",
        "onClick",
        "products",
        "expert",
        "adslayoutConfig",
        "isExtraWide",
        "hasFeedback",
        "showCategoryButton"
    ]);
    return /*#__PURE__*/ react.createElement(offers_grid/* OffersGrid */.u, {
        isExtraWide: isExtraWide,
        offers: products.map(function(product, index) {
            var raw = (0,utils_products/* isRaw */._)(product);
            return /*#__PURE__*/ react.createElement(ProductCardWrapper, _extends({
                key: !raw ? product.id : "".concat(product.name, "-").concat(index.toString()),
                onClick: function(productData) {
                    onClick === null || onClick === void 0 ? void 0 : onClick(productData.id, productData.name, productData.type, index);
                    if (!raw) (0,tracking/* trackInternalNavigationClick */.p)({
                        scope: tracking/* InternalNavigationScope.GRID_LAYOUT_PRODUCT_CARD */.U.GRID_LAYOUT_PRODUCT_CARD,
                        nextPage: product.pathName,
                        index: index
                    });
                },
                product: product,
                hasExpertBadge: !raw && product.isExpertTopRated,
                // Lazy loading is disabled for the first row of images (two first for mobile)
                // to enable images to load before React is loaded. The goal of this strategy
                // is to improve our Lighthouse performance score, and specifically the
                // "Largest Contentful Paint" metric.
                lazyLoadImage: index >= IMAGES_PER_ROW_MOBILE * 2,
                showCategoryButton: showCategoryButton
            }, productComparisonProps));
        })
    }, /*#__PURE__*/ react.createElement(ads/* Ads */.f, {
        offersLength: products.length,
        layout: types/* LayoutMode.GRID */.X.GRID,
        layoutConfig: adslayoutConfig
    }), expert && /*#__PURE__*/ react.createElement(advized/* AdvizedCarousel */._, _extends({}, expert, {
        grid: true
    })), hasFeedback && /*#__PURE__*/ react.createElement(FeedbackPrompt, {
        $position: feedbackPromptPosition
    }, feedbackPrompt));
};
// This should work because OffersGrid (src/areas/product-collection/components/offers-grid/styles) renders first and mutates ITEMS during that render
// Therefore, ITEMS here should match the items number used to render the offers grid
var FeedbackPrompt = styled_components_browser_esm["default"].li.withConfig({
    displayName: "FeedbackPrompt",
    componentId: "sc-0-0"
})(_templateObject1(), function(p) {
    return p.$position;
}, variables/* breakpointNames.map */.PS.map(function(bp) {
    return base/* media */.BC["".concat(bp, "Only")](_templateObject(), styles/* ITEMS */.cq[bp]);
}));

;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/index.tsx



/***/ }),

/***/ 27551:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": () => (/* binding */ isRaw)
/* harmony export */ });
var isRaw = function(variableToCheck) {
    return variableToCheck.__typename === "Raw" || variableToCheck.__typename === "Offer";
};


/***/ }),

/***/ 27890:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": () => (/* binding */ AddToListButton)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18026);
/* harmony import */ var _prisjakt_ui_icon_heart_filled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61739);
/* harmony import */ var _prisjakt_ui_icon_heart_outlined__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88610);
/* harmony import */ var _base_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21134);
/* harmony import */ var _add_to_list_wrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99447);






var AddToListButton = function(param) {
    var productId = param.productId, productName = param.productName, tooltipAlign = param.tooltipAlign, tooltipPlacement = param.tooltipPlacement;
    var t = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_1__/* .useAppContext */ .bp)().t;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_add_to_list_wrapper__WEBPACK_IMPORTED_MODULE_5__/* .AddToListModalsWrapper */ .w, {
        productId: productId,
        productName: productName
    }, function(onClick, addedToList) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_base_button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            isActive: addedToList,
            icon: addedToList ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_heart_filled__WEBPACK_IMPORTED_MODULE_2__/* .IconHeartFilled */ .g, null) : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_heart_outlined__WEBPACK_IMPORTED_MODULE_3__/* .IconHeartOutlined */ .G, null),
            ariaLabel: t("common", "button.save"),
            onClick: onClick,
            tooltip: t("product", "action-button.list-tooltip"),
            tooltipAlign: tooltipAlign,
            tooltipPlacement: tooltipPlacement
        });
    });
};


/***/ }),

/***/ 21134:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _prisjakt_ui_tooltip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2439);
/* harmony import */ var _prisjakt_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74007);
/* harmony import */ var _prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24980);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35848);





var BaseButton = function(param) {
    var isActive = param.isActive, icon = param.icon, ariaLabel = param.ariaLabel, tooltip = param.tooltip, _tooltipAlign = param.tooltipAlign, tooltipAlign = _tooltipAlign === void 0 ? _prisjakt_ui__WEBPACK_IMPORTED_MODULE_2__/* .Direction.Right */ .Nm.Right : _tooltipAlign, _tooltipPlacement = param.tooltipPlacement, tooltipPlacement = _tooltipPlacement === void 0 ? _prisjakt_ui__WEBPACK_IMPORTED_MODULE_2__/* .Direction.Up */ .Nm.Up : _tooltipPlacement, onClick = param.onClick, layout = param.layout;
    if (layout === "button") {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.OutlinedButton, {
            onClick: onClick
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.ButtonIcon, null, icon), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.ButtonText, null, ariaLabel));
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_tooltip__WEBPACK_IMPORTED_MODULE_1__/* .Tooltip */ .u, {
        title: tooltip,
        align: tooltipAlign,
        placement: tooltipPlacement,
        width: 180
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_4__/* .IconButton */ .hU, {
        role: "button",
        active: isActive,
        "aria-label": ariaLabel,
        onClick: onClick
    }, icon));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BaseButton);


/***/ }),

/***/ 35848:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lt": () => (/* binding */ Dropdown),
/* harmony export */   "hP": () => (/* binding */ DropdownItem),
/* harmony export */   "hU": () => (/* binding */ IconButton)
/* harmony export */ });
/* unused harmony export IconWrapper */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_dropdown_new__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16312);
/* harmony import */ var src_components_dropdown_new_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79470);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(102);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 32px;\n  height: 32px;\n  background: rgba(255, 255, 255, 0.72);\n  border-radius: 100%;\n  color: ",
        ";\n\n  svg,\n  path {\n    fill: currentcolor;\n  }\n\n  &:hover {\n    svg {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  border: 0;\n\n  ",
        " {\n    top: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 200px;\n  height: 40px;\n  display: block;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n\n  &:first-child {\n    display: flex;\n    border-bottom: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var IconButton = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].button.withConfig({
    displayName: "IconButton",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.active ? p.theme.icons.callToActionHover : p.theme.icons.secondary;
}, function(p) {
    return p.theme.icons.callToActionHover;
});
var Dropdown = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_dropdown_new__WEBPACK_IMPORTED_MODULE_1__/* .DropdownNew */ .cw).withConfig({
    displayName: "Dropdown",
    componentId: "sc-0-1"
})(_templateObject1(), src_components_dropdown_new_styles__WEBPACK_IMPORTED_MODULE_2__/* .DropdownContent */ .Nv);
var DropdownItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_dropdown_new__WEBPACK_IMPORTED_MODULE_1__/* .ListItem */ .HC).withConfig({
    displayName: "DropdownItem",
    componentId: "sc-0-2"
})(_templateObject2(), function(p) {
    return p.theme.lines.primary;
});
var IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "IconWrapper",
    componentId: "sc-0-3"
})(_templateObject3(), src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, function(p) {
    return p.theme.icons.callToAction;
});


/***/ }),

/***/ 48867:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": () => (/* binding */ AdvizedCarousel)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(38689);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.3_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(87912);
// EXTERNAL MODULE: ./src/areas/expert/components/list-of-content-cards/index.tsx + 2 modules
var list_of_content_cards = __webpack_require__(38517);
// EXTERNAL MODULE: ./src/components/advized/tracking.ts
var tracking = __webpack_require__(16646);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(102);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.3_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/card/index.js
var card = __webpack_require__(58023);
// EXTERNAL MODULE: ./src/components/info-list/index.tsx + 1 modules
var info_list = __webpack_require__(80245);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.3_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/list/variants.js
var list_variants = __webpack_require__(86541);
;// CONCATENATED MODULE: ./src/components/advized/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      display: flex;\n      padding: ",
        ";\n      padding-bottom: 0;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    display: none;\n\n    ",
        "\n  }\n\n  a {\n    max-width: max-content;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    height: 100%;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(6, minmax(240px, 1fr));\n  overflow-x: auto;\n  column-gap: ",
        ";\n  padding: ",
        ";\n\n  > * {\n    /* Set a white background color to all cards */\n    background: ",
        ";\n  }\n\n  &::after {\n    /* Adds spacing to the end of the scroll area */\n    content: '';\n    display: block;\n    width: ",
        ";\n    margin-left: -",
        ";\n    pointer-events: none;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    order: 2;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    grid-area: 4 / 1 / auto / -1;\n    display: grid;\n    background: ",
        ";\n    margin: ",
        " -",
        ";\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      min-width: 25%;\n      flex: 1 1 25%;\n\n      @media screen and (max-width: 820px) and (min-width: 520px) {\n        min-width: 33%;\n        flex: 1 1 33%;\n        order: 2 !important;\n      }\n\n      @media screen and (max-width: 520px) {\n        min-width: 50%;\n        flex: 1 1 50%;\n        order: 1 !important;\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  order: 3;\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n      margin-bottom: ",
        ";\n\n      ",
        " {\n        grid-template-columns: repeat(6, minmax(235px, 1fr));\n        padding: ",
        ";\n      }\n\n      ",
        " {\n        display: flex;\n        padding: ",
        ";\n        padding-bottom: 0;\n      }\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        " {\n      overflow-x: hidden;\n    }\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n  background: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  background-position: center center;\n  flex: 1 0 auto;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  font-weight: bold;\n  line-height: 1.25;\n  color: ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  font-weight: 800;\n  line-height: 1.5;\n  text-transform: uppercase;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-row-gap: ",
        ";\n\n  ",
        " {\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 0 auto;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  font-weight: bold;\n  line-height: 1.25;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}






var ContentCards = (0,styled_components_browser_esm["default"])(list_of_content_cards/* default */.Z).withConfig({
    displayName: "ContentCards",
    componentId: "sc-0-0"
})(_templateObject1(), base/* media.mediumUp */.BC.mediumUp(_templateObject()));
var Header = (0,styled_components_browser_esm["default"])(list_variants.Column).withConfig({
    displayName: "Header",
    componentId: "sc-0-1"
})(_templateObject3(), base/* media.smallOnly */.BC.smallOnly(_templateObject2(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
var Cards = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Cards",
    componentId: "sc-0-2"
})(_templateObject5(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, function(p) {
    return p.theme.bg.primary;
}, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.mediumUp */.BC.mediumUp(_templateObject4()));
var AdvizedListWrapper = styled_components_browser_esm["default"].li.withConfig({
    displayName: "AdvizedListWrapper",
    componentId: "sc-0-3"
})(_templateObject9(), base/* media.mediumDown */.BC.mediumDown(_templateObject6()), base/* media.smallOnly */.BC.smallOnly(_templateObject7(), function(p) {
    return p.theme.colors.maybeBlue100;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050), function(props) {
    return !props.grid && (0,styled_components_browser_esm.css)(_templateObject8());
});
var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-4"
})(_templateObject12(), base/* media.mediumUp */.BC.mediumUp(_templateObject10(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200, Cards, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, Header, base/* layout.measurements.spacing050 */.bK.measurements.spacing050), base/* media.largeUp */.BC.largeUp(_templateObject11(), Cards));
var Card = (0,styled_components_browser_esm["default"])(card.Card).withConfig({
    displayName: "Card",
    componentId: "sc-0-5"
})(_templateObject13(), function(p) {
    return p.theme.bg.primary;
});
var CardBackgroundImage = (0,styled_components_browser_esm["default"])(card.CardBackgroundImage).withConfig({
    displayName: "CardBackgroundImage",
    componentId: "sc-0-6"
})(_templateObject14());
var PreTitle = styled_components_browser_esm["default"].span.withConfig({
    displayName: "PreTitle",
    componentId: "sc-0-7"
})(_templateObject15(), base/* layout.measurements.fontSizeMedium */.bK.measurements.fontSizeMedium, function(p) {
    return base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(p.theme.colors.base0, 0.72);
});
var Title = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Title",
    componentId: "sc-0-8"
})(_templateObject16(), base/* layout.measurements.fontSizeLarge */.bK.measurements.fontSizeLarge);
var CardContent = (0,styled_components_browser_esm["default"])(card.CardContent).withConfig({
    displayName: "CardContent",
    componentId: "sc-0-9"
})(_templateObject17(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, PreTitle);
var CardActionArea = (0,styled_components_browser_esm["default"])(card.CardActionArea).withConfig({
    displayName: "CardActionArea",
    componentId: "sc-0-10"
})(_templateObject18());
var Description = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Description",
    componentId: "sc-0-11"
})(_templateObject19(), base/* layout.measurements.fontSizeMedium */.bK.measurements.fontSizeMedium);
var InfoList = (0,styled_components_browser_esm["default"])(info_list/* InfoList */.Q).withConfig({
    displayName: "InfoList",
    componentId: "sc-0-12"
})(_templateObject20(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, function(p) {
    return p.theme.colors.staticBase0;
});

// EXTERNAL MODULE: ./src/ui/block/index.ts
var block = __webpack_require__(65176);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking_tracking = __webpack_require__(58912);
;// CONCATENATED MODULE: ./src/components/advized/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}










var MIN_INFO_LIST_COUNT = 5;
var AdvizedContent = function(param) {
    var testsCount = param.testsCount, toplistsCount = param.toplistsCount, guidesCount = param.guidesCount, category = param.category, toplists = param.toplists, tests = param.tests, _numberOfCards = param.numberOfCards, numberOfCards = _numberOfCards === void 0 ? 5 : _numberOfCards, _offset = param.offset, offset = _offset === void 0 ? 0 : _offset, _hideExperts = param.hideExperts, hideExperts = _hideExperts === void 0 ? true : _hideExperts;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), linkTo = ref.linkTo, renderMode = ref.renderMode, t = ref.t;
    if (!category || !(testsCount || toplistsCount || guidesCount)) return null;
    var content = _toConsumableArray(tests || []).concat(_toConsumableArray(toplists || []));
    var getInfoListItems = function() {
        return [
            toplistsCount ? "".concat(toplistsCount, " ").concat(t("expert", "toplist.lists")) : null,
            testsCount ? "".concat(testsCount, " ").concat(t("expert", "test.tests")) : null,
            guidesCount ? "".concat(guidesCount, " ").concat(t("expert", "guide.guides")) : null
        ].filter(function(item) {
            return item;
        });
    };
    var showInfoList = (toplistsCount !== null && toplistsCount !== void 0 ? toplistsCount : 0) - offset >= MIN_INFO_LIST_COUNT;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Header, null, /*#__PURE__*/ react.createElement(variants.H3Text, null, t("expert", "widget.category-page-title")), /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: linkTo("experts"),
        onClick: function() {
            (0,tracking_tracking/* trackInternalNavigationClick */.p)({
                scope: tracking_tracking/* InternalNavigationScope.EXPERT_ADVISE_SHOW_ALL */.U.EXPERT_ADVISE_SHOW_ALL,
                nextPage: linkTo("experts")
            });
        }
    }, /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
        color: variants.FontColor.PRIMARY
    }, t("expert", "widget.category-page-link")))), /*#__PURE__*/ react.createElement(Cards, null, showInfoList && /*#__PURE__*/ react.createElement(Card, {
        outlined: false
    }, /*#__PURE__*/ react.createElement(CardActionArea, {
        container: clickable/* Clickable */.P,
        containerProps: {
            onClick: function() {
                (0,tracking/* trackCategoryPageExpertCarouselInfoList */.e)(category.url, "infoList");
                (0,tracking_tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking_tracking/* InternalNavigationScope.EXPERT_ADVISE_SHOW_ALL */.U.EXPERT_ADVISE_SHOW_ALL,
                    nextPage: linkTo("experts")
                });
            },
            to: linkTo("expertCategory", {
                semantic_id: category.url
            }, renderMode === "native" ? {
                view: "native"
            } : undefined)
        }
    }, /*#__PURE__*/ react.createElement(CardBackgroundImage, {
        src: category.descriptionImage || ""
    }, /*#__PURE__*/ react.createElement(CardContent, null, /*#__PURE__*/ react.createElement(Description, null, /*#__PURE__*/ react.createElement("span", null, t("expert", "widget.category-page-description", {
        category: category.name.toLowerCase()
    })), /*#__PURE__*/ react.createElement(InfoList, {
        list: getInfoListItems()
    })))))), /*#__PURE__*/ react.createElement(ContentCards, {
        offset: offset,
        category: category,
        items: content,
        limit: numberOfCards,
        hideExperts: hideExperts,
        trackingSource: list_of_content_cards/* TrackingSource.ADVIZED_WIDGET */.e.ADVIZED_WIDGET,
        onClick: function(onClickData) {
            return (0,tracking_tracking/* trackInternalNavigationClick */.p)({
                scope: tracking_tracking/* InternalNavigationScope.ARTICLE_CONTENT_CARD */.U.ARTICLE_CONTENT_CARD,
                nextPage: onClickData.url,
                index: onClickData.index
            });
        }
    })));
};
var AdvizedCarousel = function(props) {
    var _isList = props.isList, isList = _isList === void 0 ? true : _isList, grid = props.grid;
    return isList ? /*#__PURE__*/ react.createElement(block/* MobileOnly */.iB, null, /*#__PURE__*/ react.createElement(AdvizedListWrapper, {
        grid: grid || false
    }, /*#__PURE__*/ react.createElement(AdvizedContent, _extends({}, props)))) : /*#__PURE__*/ react.createElement(block/* MediumUp */.TD, null, /*#__PURE__*/ react.createElement(Wrapper, null, /*#__PURE__*/ react.createElement(AdvizedContent, _extends({}, props))));
};


/***/ }),

/***/ 16646:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": () => (/* binding */ trackCategoryPageExpertCarouselInfoList),
/* harmony export */   "t": () => (/* binding */ trackCategoryPageExpertCarouselCard)
/* harmony export */ });
/* harmony import */ var _client_data_layer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80695);

var trackCategoryPageExpertCarouselCard = function(pageUrl, cardType) {
    (0,_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .A)("productCollectionExpertCarouselCardClick", {
        pageUrl: pageUrl,
        cardType: cardType
    });
};
var trackCategoryPageExpertCarouselInfoList = function(pageUrl, cardType) {
    (0,_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .A)("productCollectionExpertCarouselInfoClick", {
        pageUrl: pageUrl,
        cardType: cardType
    });
};


/***/ }),

/***/ 16312:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cw": () => (/* reexport */ DropdownNew),
  "HC": () => (/* reexport */ ListItem)
});

// UNUSED EXPORTS: SharedListItemStyles

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(38828);
// EXTERNAL MODULE: ./src/components/dropdown-new/styles.ts
var styles = __webpack_require__(79470);
;// CONCATENATED MODULE: ./src/components/dropdown-new/dropdown-new.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var Dropdown = function(props) {
    var ref = _slicedToArray((0,react.useState)(false), 2), expanded = ref[0], setExpandedState = ref[1];
    var dropdownRef = (0,react.useRef)(null);
    var className = props.className, children = props.children, _grow = props.grow, grow = _grow === void 0 ? "none" : _grow, toggleElement = props.toggleElement, _showArrow = props.showArrow, showArrow = _showArrow === void 0 ? true : _showArrow, _variant = props.variant, variant = _variant === void 0 ? "primary" : _variant, onSelect = props.onSelect;
    var toggleDropdown = (0,react.useCallback)(function() {
        setExpandedState(!expanded);
    }, [
        expanded
    ]);
    var onToggleElementClick = (0,react.useCallback)(function(e) {
        if (typeof toggleElement !== "string" && toggleElement.props.onClick) {
            toggleElement.props.onClick(e);
        } else {
            e.preventDefault();
            e.stopPropagation();
            toggleDropdown();
        }
    }, [
        toggleDropdown,
        toggleElement
    ]);
    var handleClickOutside = function(e) {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
            setExpandedState(false);
        }
    };
    (0,react.useEffect)(function() {
        document.addEventListener("click", handleClickOutside);
        return function() {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    return /*#__PURE__*/ react.createElement(styles/* Dropdown */.Lt, {
        variant: variant,
        expanded: expanded,
        ref: dropdownRef,
        className: className,
        "data-test": props["data-test"]
    }, typeof toggleElement === "string" ? /*#__PURE__*/ react.createElement(components_button/* Button */.z, {
        style: styles/* sharedButtonStyles */.Rg,
        variant: "text",
        color: "link",
        onClick: toggleDropdown,
        iconPosition: "right",
        icon: showArrow ? /*#__PURE__*/ react.createElement(styles/* Arrow */.Eh, {
            expanded: expanded ? 1 : 0
        }) : null,
        "data-test": "DropdownToggle"
    }, toggleElement) : /*#__PURE__*/ react.createElement(toggleElement.type, _extends({
        style: styles/* sharedButtonStyles */.Rg,
        "data-test": "DropdownToggle"
    }, toggleElement.props, {
        onClick: onToggleElementClick,
        className: "dropdown-toggle-element"
    }), toggleElement.props.children, " ", showArrow && /*#__PURE__*/ react.createElement(styles/* Arrow */.Eh, {
        expanded: expanded ? 1 : 0
    })), /*#__PURE__*/ react.createElement(styles/* DropdownHideable */.Lr, {
        visible: expanded
    }, /*#__PURE__*/ react.createElement(styles/* DropdownContent */.Nv, {
        variant: variant,
        expanded: expanded,
        grow: grow
    }, react.Children.map(children, function(child) {
        if (!child) {
            return null;
        }
        return /*#__PURE__*/ react.cloneElement(child, _objectSpreadProps(_objectSpread({}, child.props), {
            onClick: function onClick(e) {
                if (child.props.onClick) {
                    child.props.onClick(e);
                }
                if (onSelect) {
                    onSelect(child.key || undefined);
                }
                if (child.props.to || child.props.onClick || onSelect) {
                    toggleDropdown();
                }
            },
            "data-test": "DropdownOption",
            "data-test-key": child.key
        }));
    }))));
};
var DropdownNew = /*#__PURE__*/ (0,react.memo)(Dropdown);

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(38689);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(102);
;// CONCATENATED MODULE: ./src/components/dropdown-new/item.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding: ",
        ";\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: ",
        ";\n  &:disabled {\n    color: rgba(16, 16, 16, 0.3);\n  }\n\n  svg {\n    margin-right: ",
        ";\n  }\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var SharedListItemStyles = (0,styled_components_browser_esm.css)(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.text.primary;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.dropdowns.secondary.hoverBackground;
});
var ListItem = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "ListItem",
    componentId: "sc-0-0"
})(_templateObject1(), SharedListItemStyles);

;// CONCATENATED MODULE: ./src/components/dropdown-new/index.ts





/***/ }),

/***/ 79470:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eh": () => (/* binding */ Arrow),
/* harmony export */   "Lr": () => (/* binding */ DropdownHideable),
/* harmony export */   "Lt": () => (/* binding */ Dropdown),
/* harmony export */   "Nv": () => (/* binding */ DropdownContent),
/* harmony export */   "Rg": () => (/* binding */ sharedButtonStyles)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var _prisjakt_ui_icon_chevron_down__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96159);
/* harmony import */ var _prisjakt_ui_hideable_variants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71101);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      svg,\n      path {\n        fill: currentColor;\n      }\n\n      border-color: transparent;\n\n      &:hover {\n        & > button {\n          color: ",
        ";\n        }\n      }\n\n      & > button {\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      border-color: ",
        ";\n\n      background: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    border: ",
        ";\n    border-bottom: ",
        ";\n    border-top-left-radius: ",
        ";\n    border-top-right-radius: ",
        ";\n    border-bottom-left-radius: ",
        ";\n    border-bottom-right-radius: ",
        ";\n\n    color: ",
        ";\n\n    ",
        ";\n\n    ",
        ";\n\n    .dropdown-toggle-element {\n      &:hover {\n        color: ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: 11;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      top: calc(100% - 2px);\n      left: -",
        "px;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      top: calc(100% - 2px);\n      right: -",
        "px;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      top: calc(100% - 2px);\n      left: -",
        "px;\n      right: -",
        "px;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    display: block; /* display flex + absolute position breaks in IE11 */\n    position: absolute;\n    border: ",
        ";\n    border-top: ",
        ";\n    background: ",
        ";\n    border-top-left-radius: ",
        ";\n    border-top-right-radius: ",
        ";\n    border-bottom-left-radius: ",
        ";\n    border-bottom-right-radius: ",
        ";\n\n    ",
        ";\n\n    ",
        ";\n\n    ",
        ";\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: auto;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  && {\n    transform: ",
        ";\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var borderSize = 1;
var dropdownBorder = function(props) {
    var transparent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return "".concat(borderSize, "px solid ").concat(transparent ? "transparent" : props.theme.dropdowns[props.variant].borderColor.active);
};
var sharedButtonStyles = {
    cursor: "pointer"
};
var Dropdown = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Dropdown",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject2(), dropdownBorder(props), props.expanded && props.variant === "primary" ? dropdownBorder(props, true) : dropdownBorder(props), props.theme.dropdowns[props.variant].borderRadius, props.theme.dropdowns[props.variant].borderRadius, props.expanded ? 0 : props.theme.dropdowns[props.variant].borderRadius, props.expanded ? 0 : props.theme.dropdowns[props.variant].borderRadius, props.theme.icons.tertiary, props.variant === "secondary" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject(), props.theme.icons.callToAction, props.expanded ? props.theme.icons.callToAction : undefined), props.variant !== "secondary" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject1(), props.expanded ? props.theme.dropdowns[props.variant].borderColor.active : props.theme.dropdowns[props.variant].borderColor.inactive, props.expanded ? props.theme.dropdowns[props.variant].bg : "transparent"), function(p) {
        return p.theme.buttons.link.textHover;
    });
});
var DropdownHideable = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_hideable_variants__WEBPACK_IMPORTED_MODULE_2__.NudgeUp).withConfig({
    displayName: "DropdownHideable",
    componentId: "sc-0-1"
})(_templateObject3());
var DropdownContent = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "DropdownContent",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject7(), dropdownBorder(props), props.expanded && props.variant === "primary" ? dropdownBorder(props, true) : dropdownBorder(props), props.theme.dropdowns[props.variant].bg, props.expanded ? 0 : props.theme.dropdowns[props.variant].borderRadius, props.expanded ? 0 : props.theme.dropdowns[props.variant].borderRadius, props.theme.dropdowns[props.variant].borderRadius, props.theme.dropdowns[props.variant].borderRadius, props.grow === "right" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject4(), borderSize), props.grow === "left" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject5(), borderSize), props.grow === "none" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject6(), borderSize, borderSize));
});
var arrowStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject8());
var Arrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_chevron_down__WEBPACK_IMPORTED_MODULE_1__/* .IconChevronDown */ .C).withConfig({
    displayName: "Arrow",
    componentId: "sc-0-3"
})(_templateObject9(), arrowStyles, function(p) {
    return p.expanded ? "rotate(180deg)" : "rotate(0)";
});


/***/ }),

/***/ 90369:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": () => (/* binding */ NoResults)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.3_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(87912);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.3_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/list/variants.js
var list_variants = __webpack_require__(86541);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(102);
;// CONCATENATED MODULE: ./src/components/no-results/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: left;\n  padding: 0 ",
        ";\n  margin: ",
        " 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0 ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var StyledNoResult = (0,styled_components_browser_esm["default"])(list_variants.Column).withConfig({
    displayName: "StyledNoResult",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var StyledTitle = styled_components_browser_esm["default"].p.withConfig({
    displayName: "StyledTitle",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledImage = styled_components_browser_esm["default"].img.withConfig({
    displayName: "StyledImage",
    componentId: "sc-0-2"
})(_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing150 */.bK.measurements.spacing150);

;// CONCATENATED MODULE: ./src/components/no-results/index.tsx




var NoResults = function(props) {
    var content = props.content, title = props.title;
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, t = ref.t;
    return /*#__PURE__*/ react.createElement(StyledNoResult, {
        gap: 1
    }, /*#__PURE__*/ react.createElement(variants.BodyMediumText, null, /*#__PURE__*/ react.createElement(StyledTitle, null, title), content), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(StyledImage, {
        src: "".concat(market.cdn, "/g/rfe/illustrations/no-search-result-illustration-309x229px.png"),
        srcSet: "".concat(market.cdn, "/g/rfe/illustrations/no-search-result-illustration-309x229px.png 1x, ").concat(market.cdn, "/g/rfe/illustrations/no-search-result-illustration-618x458px.png 2x"),
        alt: t("product", "results.no-product-found")
    })));
};


/***/ })

}]);